import CoachingBanner from './CoachingBanner'
export default CoachingBanner
